var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMedicalRecordIcon = function SvgMedicalRecordIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49.999,
    height: 50.011,
    viewBox: "0 0 49.999 50.011",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5297",
    "data-name": "Grupo 5297",
    transform: "translate(-709.007 -706)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5297-2",
    "data-name": "Grupo 5297",
    transform: "translate(709.007 706)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "description_FILL0_wght400_GRAD0_opsz24",
    d: "M160.207-829.989a4.815,4.815,0,0,1-3.532-1.469,4.816,4.816,0,0,1-1.469-3.532V-875a4.816,4.816,0,0,1,1.469-3.532A4.815,4.815,0,0,1,160.207-880h30l15,15v30.006a4.816,4.816,0,0,1-1.469,3.532,4.815,4.815,0,0,1-3.532,1.469ZM187.7-862.5V-875H160.207v40.009h40V-862.5ZM160.207-875v0Z",
    transform: "translate(-155.206 880)",
    fill: "#4b4b4b"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4259",
    "data-name": "Caminho 4259",
    d: "M17.047-1.537a6.889,6.889,0,0,1-.853,3.4,6.273,6.273,0,0,1-2.621,2.484,9.226,9.226,0,0,1-4.388.945H5.955v7.679H.744V-8.424H9.185a9.606,9.606,0,0,1,4.327.884A6.073,6.073,0,0,1,16.163-5.1,7.086,7.086,0,0,1,17.047-1.537ZM8.789,1.144a3.109,3.109,0,0,0,2.225-.7,2.614,2.614,0,0,0,.731-1.981,2.614,2.614,0,0,0-.731-1.981,3.109,3.109,0,0,0-2.225-.7H5.955V1.144Z",
    transform: "translate(718.667 732.624)",
    fill: "#4b4b4b"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMedicalRecordIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/medical-record-icon.d0e6f33c.svg";
export { ForwardRef as ReactComponent };